import qs from 'qs';
import { network } from 'services/network';

export const getClusterType = (params) => {
    const querystring = qs.stringify({ ProjectId: params.projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getClusterType${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
